function saveTaskFilterDialog () {
  return {
    restrict: 'E',
    templateUrl: '/workflow/dialogs/save-task-filter/save-task-filter-dialog.html?$$REVISION$$'
  }
}

export { saveTaskFilterDialog }
